import { Component, input, ChangeDetectionStrategy } from "@angular/core";
import { NgClass } from "@angular/common";

@Component({
	selector: "stages-buttons-bottom",
	templateUrl: "./buttons-bottom.component.html",
	styleUrls: ["buttons-bottom.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [NgClass],
})
export class ButtonsBottomComponent {
	readonly removeBoundaries = input<boolean>(false);

	readonly alignRight = input<boolean>(true);

	readonly isOnTop = input<boolean>(false);

	readonly addPadding = input<boolean>(false);

	readonly removeTopPadding = input<boolean>(false);
}
